export default __webpack_public_path__ + "static/media/circular_button_pressed.3d792a9a.png";